// extracted by mini-css-extract-plugin
module.exports = {"label_style":"TableCellInputOut_label_style__3dOFD","input_style":"TableCellInputOut_input_style__q2xk0","middle_style_width":"TableCellInputOut_middle_style_width__cSl5K"};